<template>
    <HelpCenterLayout v-bind="helpCenterSharedData.getHelpCenterLayoutProps()">
        <template #hero>
            <HelpCenterSearchHero />
        </template>

        <HomeSectionContainer class="px-6 py-8">
            <div class="space-y-12">
                <BreadcrumbList
                    :breadcrumbs="article.breadcrumbs"
                    class="mb-4"
                />
                <div
                    class="p-10 rounded-xl bg-white border border-stone-200 shadow-xs space-y-4"
                >
                    <div
                        class="markdown-body"
                        v-html="article.htmlContent"
                    />
                </div>
            </div>
        </HomeSectionContainer>
    </HelpCenterLayout>
</template>

<script setup lang="ts">
    import BreadcrumbList from '@/HelpCenter/Component/BreadcrumbList.vue'
    import HelpCenterSearchHero from '@/HelpCenter/Component/HelpCenterSearchHero.vue'
    import CMSArticle from '@/CMS/Content/Entity/CMSArticle'
    import HelpCenterSharedData from '@/HelpCenter/Entity/HelpCenterSharedData'
    import HomeSectionContainer from '@/HelpCenter/Component/HomeSectionContainer.vue'
    import HelpCenterLayout from '@/HelpCenter/Shared/HelpCenterLayout.vue'
    import type {
        CMSArticleRawData,
        HelpCenterSharedDataRawData,
    } from '@/Shared/AutoGenerated/Main'

    interface HelpCenterShowArticleProps {
        helpCenterSharedDataRawData: HelpCenterSharedDataRawData
        articleRawData: CMSArticleRawData
    }

    const props = defineProps<HelpCenterShowArticleProps>()

    const helpCenterSharedData = HelpCenterSharedData.hydrate(
        props.helpCenterSharedDataRawData,
    )
    const article = CMSArticle.hydrateSingle(props.articleRawData)
</script>
